import React from "react";

const Empty = (props) => {
  const imgSrc = props.Image || require("assets/images/empty-icon.svg").default;
  return (
    <div className="empty-block">
      <img src={imgSrc} alt="icon" />
      <h4>{props.Message}</h4>
      {props?.anotherChild ?? null}
    </div>
  );
};

export default Empty;
